export const BtnDefault = ({ type = "button", children, className = "", onClick, disabled }) => {
    return (
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`
          inline-flex items-center justify-center gap-2
          font-semibold text-sm
          py-2.5 px-5 rounded-xl
          transition-all duration-300 ease-out
          relative overflow-hidden
          cursor-pointer select-none
          border-none outline-none
          font-body
          ${disabled
            ? "opacity-40 cursor-not-allowed"
            : "hover:-translate-y-0.5 hover:shadow-lg hover:shadow-cyan-600/20 active:translate-y-0 active:shadow-none"
          }
          ${className}
        `}
        style={{
          background: "linear-gradient(135deg, #0077B6, #00B4D8)",
          color: "#fff",
          boxShadow: disabled ? "none" : "0 4px 15px rgba(0, 180, 216, 0.2)",
        }}
      >
        {/* Shimmer hover effect */}
        {!disabled && (
          <span
            className="absolute top-0 left-[-100%] w-full h-full pointer-events-none"
            style={{
              background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.12), transparent)",
              transition: "left 0.6s ease",
            }}
            onMouseEnter={(e) => { e.target.style.left = "100%"; }}
            onMouseLeave={(e) => { e.target.style.left = "-100%"; }}
          />
        )}
        <span className="relative z-10 flex items-center gap-2">{children}</span>
      </button>
    );
  };